import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import RowButton from "../../../components/ui_comps/RowButton";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";

const Container = ({ title, value }) => {
  return (
    <div
      style={{
        width: "90%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginLeft: 20,
        marginBottom: 20,
      }}
    >
      <p style={{ fontSize: 14 }}>{title}</p>
      <p style={{ fontSize: 14 }}>{value}</p>
    </div>
  );
};
function AddFundsModal({ onSuccess }) {
  const { enqueueSnackbar } = useSnackbar();
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState("");
  const [clientData, setClientData] = useState("");
  const [balance, setBalance] = useState("");
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    height: 50,
    marginBottom: 20,
    width: "100%",
  };

  const textStyle = {
    fontSize: 12,
    color: "#6C6B6B",
    margin: "5px 0px 5px 20px",
  };

  const onClickAddFunds = () => {
    if (!amount && !description) {
      enqueueSnackbar("Please enter all the details", {
        variant: "error",
      });
      return;
    }
    setLoading(true);
    ApiRequestPost.addFundsEquitas({
      clientId: clientData?.clientId,
      programId: clientData?.program,
      amount: parseFloat(amount).toFixed(2),
      remarks: description,
      serviceProviderName: clientData?.serviceProviderName,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response?.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(
            response?.message?.message
              ? response?.message?.message
              : response?.message?.txnStatus
              ? response?.message?.txnStatus
              : "Failed",
            {
              variant: "error",
            }
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        enqueueSnackbar(error?.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  const fetchClientCurrentBalance = () => {
    if (clientData?.serviceProviderName?.toUpperCase() === "EQUITAS") {
      ApiRequestGet.fetchClientCurrentBalance({
        client_secret: clientData?.clientId,
        program_id: clientData?.program,
      })
        .then((response) => {
          if (response.statusCode === STATUS_CODE_200) {
            setBalance(response?.data?.availableBal);
          }
        })
        .catch((error) => {});
    }

    if (clientData?.serviceProviderName?.toUpperCase() === "ZYRO") {
      ApiRequestGet.fetchZyroClientCurrentBalance({
        client_secret: clientData?.clientId,
        program_id: clientData?.program,
      })
        .then((response) => {
          if (response.statusCode === STATUS_CODE_200) {
            setBalance(response?.data?.availableBal);
          }
        })
        .catch((error) => {});
    }
    if (clientData?.serviceProviderName?.toUpperCase() === "AXIS") {
      ApiRequestGet.fetchAxisClientCurrentBalance({
        client_secret: clientData?.clientId,
        program_id: clientData?.program,
      })
        .then((response) => {
          if (response.statusCode === STATUS_CODE_200) {
            setBalance(response?.data?.Balance);
          }
        })
        .catch((error) => {});
    }
    if (clientData?.serviceProviderName?.toUpperCase() === "IDFC") {
      ApiRequestGet.fetchIdfcClientCurrentBalance({
        client_secret: clientData?.clientId,
        program_id: clientData?.program,
      })
        .then((response) => {
          if (response.statusCode === STATUS_CODE_200) {
            setBalance(response?.data?.Balance);
          }
        })
        .catch((error) => {});
    }
  };

  useEffect(() => {
    let payout = clientSecret.filter(
      (obj) =>
        obj?.serviceType?.toUpperCase() === "PAYOUT" &&
        (obj.serviceProviderName?.toUpperCase() === "EQUITAS" ||
          obj.serviceProviderName?.toUpperCase() === "ZYRO" ||
          obj.serviceProviderName?.toUpperCase() === "AXIS" ||
          obj.serviceProviderName?.toUpperCase() === "IDFC")
    );
    if (payout?.length !== 0) {
      setClientData(payout[0]);
    }
  }, []);

  useEffect(() => {
    if (clientData) {
      fetchClientCurrentBalance();
    }
  }, [clientData]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <div>
        <p style={textStyle}>Enter Amount</p>
        <CustomInput
          value={amount}
          onChange={(data) => setAmount(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Amount"
          validator="decimal"
          type="input"
          inputStyles={{
            ...containerStyle,
            marginBottom: 5,
          }}
        />
      </div>

      <p style={{ marginBottom: 10, fontSize: 12, marginLeft: 20 }}>
        Current account balance : {balance ? balance : 0}
      </p>
      <div>
        <p style={textStyle}>Description</p>

        <CustomInput
          value={description}
          onChange={(data) => setDescription(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Description"
          validator="companyName"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>

      {/* <div>
        <Container title={"Total Amount"} value={amount ? amount : 0} />
        <Container title={"Fees"} value={amount ? amount : 0} />
        <Container title={"Gst"} value={amount ? amount : 0} />
        <Container title={"Final Amount"} value={amount ? amount : 0} />
      </div> */}

      <RowButton
        loading={loading}
        onClickBack={() => {
          onSuccess();
        }}
        onClickNext={() => {
          onClickAddFunds();
        }}
        buttonname2="Submit"
      />
    </div>
  );
}

export default AddFundsModal;
